import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';

var _templateObject = _taggedTemplateLiteral(['\n  display: block;\n  width: 16px;\n  height: 16px;\n  border: 4px solid white;\n  border-radius: 50%;\n  background-color: red;\n'], ['\n  display: block;\n  width: 16px;\n  height: 16px;\n  border: 4px solid white;\n  border-radius: 50%;\n  background-color: red;\n']);

import React from 'react';
import styled from 'styled-components';

export default (function (_ref) {
  var className = _ref.className,
      rest = _objectWithoutProperties(_ref, ['className']);

  return React.createElement(RedDot, _extends({}, rest, { className: className + ' red-dot' }));
});

var RedDot = styled.div(_templateObject);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/RedDot/index.js
// module id = 419
// module chunks = 0